import useQuestionPageStyles from './useQuestionPageStyles';
import QuestionHeader from './header';
import QuestionView from './question';
import useQuestionPage from '../../../hooks/useQuestionPage';
import useGlobalStyles from '../../useGlobalStyles';
import useLayoutStyles from '../../layout/useLayoutStyles';
import GameParrot from '../gameParrot';
import LoadingScreen from '../../loadingScreen';

/**
 * QuestionPage component renders a page displaying a list of questions
 * based on filters such as order and search terms.
 * It includes a header with order buttons and a button to ask a new question.
 */
const QuestionPage = () => {
  const { classes } = useQuestionPageStyles();
  const { classes: layoutClasses } = useLayoutStyles();
  const { classes: globalClasses } = useGlobalStyles();

  const { titleText, qlist, questionOrder, setQuestionOrder } = useQuestionPage();

  if (!qlist) {
    return <LoadingScreen />;
  }

  return (
    <>
      <div className={layoutClasses.container}>
        <QuestionHeader
          titleText={titleText}
          qcnt={qlist.length}
          questionOrder={questionOrder}
          setQuestionOrder={setQuestionOrder}
        />
        <div id='question_list'>
          {qlist.map((q, idx) => (
            <QuestionView q={q} key={idx} />
          ))}
        </div>
        {titleText === 'Search Results' && !qlist.length && (
          <div className={`${globalClasses.notExist} ${classes.noQuestions}`}>
            No questions found.
          </div>
        )}
      </div>
      <GameParrot />
    </>
  );
};

export default QuestionPage;
